import { render, staticRenderFns } from "./Vacia_Productos_carrito.vue?vue&type=template&id=43686c67&"
import script from "./Vacia_Productos_carrito.vue?vue&type=script&lang=js&"
export * from "./Vacia_Productos_carrito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports